export default __webpack_public_path__ + "static/media/B.696aeeb3.svg";